
export type Link = {
  text: string;
  href: string;
}

export enum Platform {
  TikTok,
  Instagram
}

export enum Genre {
  Food,
  Finance,
  Lifestyle,
  Beauty,
  Tech,
  Gaming,
  Travel,
  Entertainment,
  Running,
  Pets,
  Fashion,
  Fitness,
  Comedy,
  Family,
  Other
}

export enum ResearchCreatorStatus {
  Unset,
  ReachedOut,
  Bumped,
  Courting,
  Signed,
  Revisit
}

export type Video = {
  id: string;
  handle: string;
  description: string;
  scrapeDate: Date;
  platform: Platform,
  paidAd: boolean;
  postDate: Date;
  commentCount: number;
  views: number;
  likes: number;
  links: Link[];
}

export type PartnerTags = {
  id: string;
  tag: string;
  viewCount: number;
  postDate: Date;
  videoId: string;
  handle?: string;
}

export type ResearchCreator = {
    id: string;
    genre: Genre;
    status: ResearchCreatorStatus;
    tiktok: string;
    tiktokFollowers: number;
    instagram: string;
    instagramFollowers: number;
    emailInBioChange: Array<{ oldEmail: string; newEmail: string; changeDate: string }>;
    addedDate: Date;
    addedBecause: string;
    lastScrapeDate: Date;
    deleted: boolean;
    videosScraped: number;
    avgVideoViewCount: number;
    viewCountStandardDeviation: number;
    partnerTags: PartnerTags[];

}

export enum ScrapeStatus {
  Unset,
  ScrapeRequested,
  ScrapeComplete
}

export type ResearchLink = {
  id: string;
  href: string;
  count: number;
  scrapeStatus: ScrapeStatus;
  deleted: boolean;
  companyName: string;
  companyWebsite: string;
  marketingAgency: string;
  agencyContactPhone: string;
  agencyContactEmail: string;
  competitors: string[];
}

